import PropTypes from 'prop-types'

import {cobrandingPrefixText} from '../../lib/cobrandingTools'

import './mobileFooterEverplansBrandedCobranding.scss'


const MobileFooterEverplansBrandedCobranding = ({
  cobranding = {
    cobrandable: {
      name: ''
    },
    cobranding_prefix: '',
    logo_url: ''
  }
}) => (
  <footer className='mobile-footer-everplans-branded-cobranding'>
    {cobranding.cobranding_prefix}
    <img alt={cobrandingPrefixText(cobranding)} src={cobranding.logo_url} />
  </footer>
)

MobileFooterEverplansBrandedCobranding.propTypes = {
  cobranding: PropTypes.shape({
    cobrandable: PropTypes.shape({
      name: PropTypes.string
    }),
    cobranding_prefix: PropTypes.string,
    logo_url: PropTypes.string
  })
}

export default MobileFooterEverplansBrandedCobranding
